// Süper admin › Tahsilat › Bayi Bildirimleri sekmesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.dealerNotices';

export const dealerNoticesGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Bayi Bildirimleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bayiye bağlı şirketlerin süresi dolacak sözleşme, ürün, demo ve yazarkasa kalemleri için bayiye hatırlatma gönderirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Bayi Bildirimleri'),
    filters: t(`${G}.regions.filters`, 'Durum'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Bildirim'),
    table: t(`${G}.regions.table`, 'Bildirim listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bayi bildirimi nasıl çalışır?'),
      text: t(`${G}.s1.text`, 'Bayi şirketi veya şubesi için bildirimi buradan siz açarsınız; açılmayan kayda mail gitmez. Açılan kayıtta hatırlatma, bitişe 30, 15 ve 7 gün kala bayinin e-postasına birer kez gider. Telefon doluysa aynı eşikte SMS de gider.'),
      tips: [
        t(`${G}.s1.tip1`, 'Mail ve SMS metinleri sağ üstteki Ayarlar menüsünden (Şablonlar › Bayi bildirimi) düzenlenir.'),
        t(`${G}.s1.tip2`, 'Bayi bildirimi tahsilat kaydı açmaz; yalnız bayiye hatırlatma gönderir.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Duruma göre süzün'),
      text: t(`${G}.s2.text`, '"Durum" ile Tümü, Açık, Kapatılan veya İptal kayıtlarını listeleyin.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Yeni Bildirim açın'),
      text: t(`${G}.s3.text`, '"Yeni Bildirim" penceresinde önce Bayi\'yi, sonra o bayiye bağlı Şirket\'i seçin. Şirketin bitiş tarihi olan sözleşme, ürün, demo ve yazarkasa kalemleri listelenir; işaretlediğiniz her kalem ayrı bildirim olarak eklenir.'),
      tips: [
        t(`${G}.s3.tip1`, '"Zaten açık" yazan kalem için açık bir bildirim vardır; ikinci kez eklenemez.'),
        t(`${G}.s3.tip2`, 'Bayi e-postası zorunludur, hatırlatma bu adrese gider. Bayi seçince e-posta ve telefon bayinin kaydından dolar; değiştirebilirsiniz.'),
        t(`${G}.s3.tip3`, 'Kaydettiğinizde eşik gelmiş kalemler için hatırlatma maili hemen gider.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Listeyi okuyun ve düzenleyin'),
      text: t(`${G}.s4.text`, 'Her satırda bayi, şirket / şube, kalem, bitiş tarihi ve kalan gün görünür. "Giden hatırlatma" sütununda 30, 15 ve 7 çiplerinden yeşil olanlar gönderilmiş hatırlatmalardır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Açık bir satıra tıklayınca Kalem, Ayrıntı, Bitiş tarihi, e-posta, telefon ve not düzenlenir. Bayi ve şirket değiştirilemez; kapatılan veya iptal edilen kayıt düzenlenemez.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Bildirimi kapatın ya da iptal edin'),
      text: t(`${G}.s5.text`, 'Açık satırdaki onay simgesi (Kapat) yenileme yapıldığında kaydı kapatır; çarpı simgesi (İptal) kaydı iptal eder. İkisinde de sonraki 30, 15, 7 gün hatırlatmaları gitmez.'),
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezinin'),
      text: t(`${G}.s6.text`, 'Liste uzunsa alttaki sayfalamayı kullanın; sayfada 25, 50 veya 100 satır gösterebilirsiniz.'),
    },
  ],
});
